import React, { useEffect } from 'react';
import { Button, Form, Input, Radio } from 'antd';
import { EyeTwoTone, EyeInvisibleOutlined } from '@ant-design/icons';
import { FormSection } from 'ui/FormSection';
import { SectionTitle } from 'ui/SectionTitle';
import { FormWrapper } from 'ui/FormWrapper';
import { requiredRule } from 'utils/forms/validationRules';
import { AccessControl } from 'components/AccessControl';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';

function IntegrationForm({ pageId, formTitle, onSubmit, config }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (config) {
      form.setFieldsValue(config);
    }
  }, [config]);

  return (
    <FormWrapper style={{ padding: '0 30px' }}>
      <Form
        form={form}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
        onFinish={onSubmit}
      >
        <FormSection>
          <SectionTitle>{formTitle}</SectionTitle>

          <Form.Item name="login" label="Логин" rules={[requiredRule]}>
            <Input placeholder="Введите логин" />
          </Form.Item>

          <Form.Item name="password" label="Пароль" rules={[requiredRule]}>
            <Input.Password
              placeholder="Введите пароль"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
          </Form.Item>

          <Form.Item
            name="integration"
            label="Интеграция"
            rules={[requiredRule]}
          >
            <Radio.Group>
              <Radio value="1">Включить</Radio>
              <Radio value="0">Выключить</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name="url"
            label="Точка подключения"
            rules={[requiredRule]}
          >
            <Input placeholder="Введите URL" />
          </Form.Item>

          <AccessControl pageId={pageId} action="update">
            <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
              <Button type="primary" htmlType="submit">
                Сохранить
              </Button>
            </Form.Item>
          </AccessControl>
        </FormSection>
      </Form>
    </FormWrapper>
  );
}

export { IntegrationForm };
